<template>
  <div>
    <disqualification-template ref="template" :orderStatus="1" type="approve"/>
    <vxe-loading v-model="loading"/>
  </div>
</template>

<script>
import DisqualificationTemplate from '@/views/quality/disqualification/DisqualificationTemplate.vue'

export default {
  name: 'DisqualificationConfirm',
  components: { DisqualificationTemplate },
  data() {
    return {
      loading: false
    }
  },
  methods: {}
}
</script>